import "./BenefitsCard.css";

const BenefitCard = ({ text }) => {
  return <div className="benefits-card">{text}</div>;
};
export default BenefitCard;
